import 'core-js/client/core';
import './tools/forEachPolyfill';
import smoothscroll from 'smoothscroll-polyfill';
import populate from './tools/populate';
import Modal from './components/modal/index';
import Menu from './components/menu/index';
import Accordion from './components/accordion';
import Tabs from './components/tabs/index';
import * as playPauseBtn from './components/play-pause-btn';

// So that we can view atoms and blocks from RTL
document.addEventListener('DOMContentLoaded', () => {
    const url = window.location.href;
    // eslint-disable-next-line no-magic-numbers
    if (url.indexOf('?rtl') !== -1) {
        const html = document.querySelector('html');
        const body = document.querySelector('body');
        html.setAttribute('dir', 'rtl');
        body.classList.add('is-rtl');
    }

    // Smooth scrolling for anchor links to a element on the page
    smoothscroll.polyfill();

    if (document.querySelectorAll('.play-pause').length > 0) {
        playPauseBtn.init();
    }
});

// make secondary navigation sticky on scroll
const menu = document.querySelector('.menu-secondary');
let sticky;

if (menu !== null) {
    sticky = menu.offsetTop;
}

window.onscroll = () => {
    if (window.pageYOffset >= sticky) {
        menu.classList.add('menu-secondary--sticky');
    } else {
        menu.classList.remove('menu-secondary--sticky');
    }
};

const initializeComponents = () => {
    Modal.init();
    Accordion.init();
    Tabs.init();
    Menu.init();
};

const body = document.querySelector('body');

/*
 * fetch('/assets/content.json').
 *     then(response => response.json()).
 *     then(data => {
 *         populate(data);
 *         initializeComponents();
 *         body.classList.remove('loading');
 *     }).
 *     catch(error => {
 *         body.classList.remove('loading');
 *         body.classList.add('data-error');
 *         // eslint-disable-next-line no-console
 *         console.error(error);
 *     });
 */

function successListener() {
    const data = JSON.parse(this.responseText);
    populate(data);
    initializeComponents();
    body.classList.remove('loading');
}

function failureListener(err) {
    body.classList.remove('loading');
    body.classList.add('data-error');
    // eslint-disable-next-line no-console
    console.log('Request failed', err);
}

const request = new XMLHttpRequest();
request.onload = successListener;
request.onerror = failureListener;
request.open('get', './assets/content.json', true);
request.send();

// this tells webpack this file is available for HMR
if (module.hot) {
    module.hot.accept();
}
